import React, { Component } from "react";
import { observer } from "mobx-react";
import Modal from "../views/Modal";
import ErrorStore from "./ErrorStore";
import { Button } from "../views/Button";
import { markdownProps } from "../views/MarkdownRenderers";
import ReactMarkdown from "react-markdown";
import { itemTypeToWord } from "../../core/views/OmniSearch";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { getItemUriByItemType } from "../omni";

type ErrorViewProps = {
  errorStore: ErrorStore;
};

@observer
export class ErrorView extends Component<ErrorViewProps> {
  ok(shouldRetry: boolean) {
    this.props.errorStore.ok({ shouldRetry });
  }

  cancel(goBack: boolean) {
    this.props.errorStore.cancel({ goBack });
  }

  render() {
    const errorStore = this.props.errorStore;
    const error = errorStore.error;

    if (!error) {
      return null;
    }

    const cancelButton = (
      <Button onClick={() => this.cancel(false)} type="cancel">
        Cancel
      </Button>
    );

    const forceInformation = error.forceInformation;
    const title = forceInformation ? forceInformation.title : "Whoops!";
    const actionButtonType = (forceInformation && forceInformation.buttonType) || "danger";
    const relatedItem = forceInformation && forceInformation.relatedItem;

    return (
      <Modal
        isOpen={true}
        title={<Typography variant="h4">{title}</Typography>}
        className="create-feature-form"
        onRequestClose={() => this.ok(false)}
        actions={
          <Box width="100%" display="flex" justifyContent="space-between">
            <Box>
              {forceInformation && (
                <Button onClick={() => this.ok(true)} type={actionButtonType} automationName="discard-warning">
                  {forceInformation.ok}
                </Button>
              )}
              {relatedItem && (
                <Link to={getItemUriByItemType(relatedItem)}>
                  <Button onClick={() => this.ok(false)} type="secondary">
                    Go to {itemTypeToWord[relatedItem.itemType.clazz] || "Related Object"}
                  </Button>
                </Link>
              )}
            </Box>
            <Box>{!(forceInformation && forceInformation.noCancel) && cancelButton}</Box>
          </Box>
        }
      >
        <ReactMarkdown className="description" {...markdownProps}>
          {error.detailMessage}
        </ReactMarkdown>
      </Modal>
    );
  }
}
